import { useState, useRef, useEffect, useContext, useCallback } from "react";
import { useNavigate  } from "react-router-dom";
import { DDD,
        E2Data,
        copyExistingToNew,
        getInvoiceValuesFromMergedDDDIAndUI} from "../lib/ddd/ddd";
import { Helmet } from "react-helmet";
import classes from "./IntegrationWizard.module.scss";
import { useQuery } from "@tanstack/react-query";
import ActiveInvoicePicker from "../components/integrationWizard/ActiveInvoicePicker";
import Steps from "../components/integrationWizard/Step/Steps";
import { UserUIStateContext } from "../store/userUIStateContext";
import { OrgIdContext } from "../store/orgId_context";
import InvoiceDisplayIframe from "../components/integrationWizard/InvoiceDisplayIframe";
import Docs from "../components/integrationWizard/Docs";
import { Tab, Tabs } from "@mui/material";
import InvoiceDocsIframe from "../components/integrationWizard/InvoiceDocsIframe";
import beautify from "xml-beautifier";
import InvoiceDocsXml from "../components/integrationWizard/InvoiceDocsXml";
import xmlFormat from 'xml-formatter';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import Looks3Icon from '@mui/icons-material/Looks3';
import ForwardIcon from '@mui/icons-material/Forward';
import { NavLink } from "react-router-dom";
import Button from "../components/UI/Button";
import { MenuContext } from "../store/menu_context";


const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);
const e2data = new E2Data("EU_Invoices");
//data.filter='DeviceId__AssignedTo="CKI"  AND DeviceId__Integration=true';

const IntegrationDocs = () => {
    const {menuFunctions} =  useContext(MenuContext);
    const [currentInvoiceId, setCurrentInvoiceId] =  useState(/*"44de78e7-94fc-11ee-9108-ee67f6910206"*/);
    const {saveValues, integrationData, setIntegrationDataHandler} = useContext(UserUIStateContext);
    const { integrationDevice} = useContext(OrgIdContext);
    const [executeResponse, setExecuteResponse] = useState();
    const [tab, setTab] = useState(0);
    const [currentUrl, setCurrentUrl] = useState();
    const [currentTabText, setCurrentTabText] = useState();
    const [tabs, setTabs] = useState({});
    const [xmlData, setXmlData] = useState();
    const navigate = useNavigate();


    useEffect(() =>{
        if(!currentInvoiceId && integrationData?.currentInvoiceId)
            setCurrentInvoiceId(integrationData.currentInvoiceId);
        onExecute({});
    },[integrationData]);

    const onInvoiceSelected = (invoice) => {
        setCurrentInvoiceId(invoice.Id);
        loadNewInvoiceAsActive(invoice.Id);
        setTabs({});
        setXmlData("");
        setCurrentUrl(null);
    }

    const loadNewInvoiceAsActive = (id) => {
        const ddd = DDD.WithConnectionKey(apiRequestAddress, integrationDevice);
        ddd.APP_GetNewAndExisting({Complexity:"Normal"}, id).then(res => {
            console.log(res);
            const invoice = res?.DDDI_GetNew?.Invoice?.Invoice;
            const existing = res?.UI_GetExisting?.Invoice;
            if(!invoice || !existing)
                return console.error("No existing or new invoice found. Stopped loading UI state");
            const newInvoice = copyExistingToNew(invoice, existing);

            if(newInvoice)
                setIntegrationDataHandler({...integrationData, currentInvoiceId:id, invoiceJson:{Object : newInvoice, Complexity : "Normal"}});
        })
    }

    const onExecute = (res) => {
        /*res.Result={
            "PDF" : "https://e-invoices.online/File/0be2c0e9-9d36-4992-8fc4-915c810d3493?inline=true",
            "XML" : "xml_example.xml",
            "XMLS" : "xml_example_normal.xml"
        }*/
        setExecuteResponse(res);
        
        console.log(res);
        if(res?.Result){
            setTabs(res.Result);
            const current=  Object.keys(res.Result)[0];
            setCurrentUrl(res.Result[Object.keys(res.Result)[0]])
            setCurrentTabText(current);
            if(["XMLP", "XMLS"].indexOf(current)>-1)
                reloadXml(res.Result[current]);
        }else{
            setTabs({});
        }
    }

    const onCreateNew = () =>{
        setIntegrationDataHandler({...integrationData, currentInvoiceId:null});
        navigate("/integration-wizard");
    }

    const onTabChange = (e, val) => {
        setTab(val);
        setCurrentUrl(executeResponse.Result[Object.keys(executeResponse.Result)[val]])
        const current=  Object.keys(executeResponse.Result)[val];
        setCurrentTabText(current);
        if(["XMLP", "XMLS"].indexOf(current)>-1)
            reloadXml(executeResponse.Result[current]);
    }

    const reloadXml = (path) => {
        if(!path)
            return setXmlData("");
        fetch(path)
            .then(res => res.text())
            .then(xmlString => {
                setXmlData(xmlString);
            })
    }

    const openStepsInTree = (e) => {
        /*if(menuFunctions?.openNodeToPath)
            menuFunctions.openNodeToPath(["Administration", "My company", ]);*/
    }

    return(
        <>
        <Helmet>
            <title>Integration Documents | DDD Invoices</title>
        </Helmet>
       
        <div className={`w-100 h-100 ${classes.container} ${classes["p-lrb-5"]}`}>
            <div className="flex d-flex">
                <div className={classes["blankTitle"]}>Active invoice</div>
                <div style={{marginLeft: "auto", paddingRight:"0.5rem", marginTop:"1rem", whiteSpace:"nowrap"}}>
                {currentInvoiceId && <NavLink to="/integration-wizard" state={{activeTab:"edit"}}><Button id="activeInvoiceBtn" style={{marginRight:"1rem"}}><ForwardIcon style={{marginRight:"1rem", transform:"rotate(180deg)"}}/>Edit invoice<LooksOneIcon style={{marginLeft:"1rem"}}/></Button></NavLink>}
                    <NavLink to="/integration-wizard-step"><Button id="activeInvoiceBtn" style={{marginRight:"1rem"}} onClick={openStepsInTree}><LooksTwoIcon style={{marginRight:"1rem"}}/>Go to steps<ForwardIcon style={{marginLeft:"1rem"}}/></Button></NavLink>
                </div>
            </div>
            <ActiveInvoicePicker invoiceId={currentInvoiceId} onCreateNew={onCreateNew} onInvoiceSelected={onInvoiceSelected} onExecuteResponse={executeResponse}/>
            <div className={classes["blankTitle"]}>Documents</div>
            <div className={`${classes["container-panel"]}`} style={{height:"auto"}}>
                <Docs invoiceId={currentInvoiceId} onExecute={onExecute}/>
            </div>
            
            {Object.keys(tabs).length > 0 && <>
                <div className={classes["blankTitle"]}>Preview</div>
                <div style={["PDF", "PDFO"].indexOf(currentTabText)>-1 ? {height:"100vh"} : {}}>
                    <Tabs value={tab} onChange={onTabChange} centered>
                        {Object.keys(tabs).map(doc => {
                            return <Tab label={doc}/>
                        })}
                    </Tabs>
                    {["PDF", "PDFO"].indexOf(currentTabText)>-1 && <InvoiceDocsIframe url={currentUrl}/>}
                    {["XMLP", "XMLS"].indexOf(currentTabText)>-1 && <InvoiceDocsXml xml={xmlData}/>}
                </div>
            </>}
        </div>
        </>
    )
}
export default IntegrationDocs;